import { render, staticRenderFns } from "./TncTable.vue?vue&type=template&id=67bf5050&scoped=true&"
import script from "./TncTable.vue?vue&type=script&lang=js&"
export * from "./TncTable.vue?vue&type=script&lang=js&"
import style0 from "./TncTable.vue?vue&type=style&index=0&id=67bf5050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf5050",
  null
  
)

export default component.exports